import { useState, type FormEvent } from 'react'
import { Alert, Box, Button, Card, CardContent, Stack, TextField, Typography, CircularProgress } from '@mui/material'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useAuth } from '../auth/AuthContext'
import { errorMessage } from '../api/client'

export default function Login() {
  const { t } = useTranslation()
  const { login } = useAuth()
  const [userNameOrEmail, setUser] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState<string | null>(null)
  const [busy, setBusy] = useState(false)

  async function submit(e: FormEvent) {
    e.preventDefault()
    setError(null)
    setBusy(true)
    try {
      await login(userNameOrEmail, password)
    } catch (err) {
      setError(errorMessage(err, t('login.failed')))
    } finally {
      setBusy(false)
    }
  }

  return (
    <Box sx={{
      minHeight: '100vh', display: 'grid', placeItems: 'center',
      bgcolor: 'background.default', p: 2,
    }}>
      <Card variant="outlined" sx={{ width: '100%', maxWidth: 400 }}>
        <CardContent sx={{ p: 4 }}>
          <Stack spacing={0.5} sx={{ mb: 3 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
              <Box sx={{
                width: 30, height: 30, borderRadius: 1.4, bgcolor: 'primary.main', color: '#fff',
                display: 'grid', placeItems: 'center', fontWeight: 700,
              }}>C</Box>
              <Typography variant="h6">CIPRAL</Typography>
            </Box>
            <Typography variant="h3">{t('login.title')}</Typography>
            <Typography variant="body2" color="text.secondary">{t('login.subtitle')}</Typography>
          </Stack>

          <form onSubmit={(e) => void submit(e)}>
            <Stack spacing={2}>
              <TextField
                label={t('login.user')} value={userNameOrEmail}
                onChange={(e) => setUser(e.target.value)}
                autoComplete="username" autoFocus required fullWidth
              />
              <TextField
                label={t('login.password')} type="password" value={password}
                onChange={(e) => setPassword(e.target.value)}
                autoComplete="current-password" required fullWidth
              />
              {error && <Alert severity="error" variant="outlined">{error}</Alert>}
              <Button
                type="submit" variant="contained" size="large" fullWidth disabled={busy}
                startIcon={busy ? <CircularProgress size={16} color="inherit" /> : undefined}
              >
                {t('login.submit')}
              </Button>
            </Stack>
          </form>

          <Typography variant="body2" sx={{ mt: 2.5, textAlign: 'center' }}>
            <Link to="/forgot-password">Ați uitat parola?</Link>
          </Typography>
        </CardContent>
      </Card>
    </Box>
  )
}
